import type {
  JustifyContentProperty,
  TextAlignProperty,
} from '@mentimeter/ragnar-styled';
import { TextFitGhost } from '@mentimeter/visualizations-react/components/text-fit-ghost';
import { useRef, type PropsWithChildren } from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';

export interface BigTextProps {
  text: string;
  textAlign: TextAlignProperty;
  justifyContent: JustifyContentProperty;
}

const FONT_SIZES = [
  '12px',
  '24px',
  '28px',
  '32px',
  '45px',
  '60px',
  '70px',
  '80px',
  '120px',
  '150px',
  '200px',
  '300px',
  '400px',
  '500px',
];

export const BigText = ({
  text,
  textAlign,
  justifyContent,
  children,
}: PropsWithChildren<BigTextProps>) => {
  const textContainerRef = useRef<HTMLDivElement>(null);

  return (
    <Box
      ref={textContainerRef}
      width="100%"
      height="100%"
      justifyContent={justifyContent}
    >
      <TextFitGhost
        text={text}
        fontSizes={FONT_SIZES}
        width="100%"
        height="100%"
        finalFontSizeContainerRef={textContainerRef}
      >
        {(ref) => (
          <Text
            ref={ref}
            textAlign={textAlign}
            fontWeight="semiBold"
            lineHeight="none"
            fontFamily="heading"
          >
            {text}
          </Text>
        )}
      </TextFitGhost>
      <Text
        as="h1"
        width="100%"
        color="text"
        fontSize="inherit"
        textAlign={textAlign}
        fontWeight="semiBold"
        lineHeight="none"
        fontFamily="heading"
        data-testid="big-text-children"
      >
        {children}
      </Text>
    </Box>
  );
};
